// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b82699ad","224":"5975e45d","237":"e673ff9c","427":"8b6e0724","455":"3054ad57","477":"0471584c","582":"62e02588","629":"d83a2d0a","638":"045acb93"}[chunkId] + ".chunk.js";
};